import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Table, Pagination, Menu, Button, Dropdown, Icon, Spin, Modal } from "antd"
import AddAffiliate from './AddAffiliate'
import Permissions from './Permissions'
import Settings from './Settings';
import {changeStatusAffiliate, getAffiliates, getProjectId} from "../../../actions/AffiliateActions";
import AdvanceWithdraw from "./AdvanceWithdraw";
import configs from "../../../constants/Configs";
import {Auth} from "../../../services/Auth";
import {Utils} from "../../../services/Utlis";

const confirm = Modal.confirm;

class Affiliates extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            settingsVisible: false,
            permissionVisible: false,
            closeDeleteModal: false,
            pageNumber: 1
        };
    }

    componentDidMount() {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        mainPartnerId && this.props.dispatch(getAffiliates(mainPartnerId, pageNumber));
    }

    onPageChange = (current) => {
        this.setState({ pageNumber: current });
    }

    // On page change get new data
    componentDidUpdate(prevProps, prevState) {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        if (prevState.pageNumber !== pageNumber || prevProps.affiliates.mainPartnerId !== mainPartnerId) {
            this.props.dispatch(getAffiliates(mainPartnerId, pageNumber));
        }
    }

    handleChangeStatusAffiliate(e, row, status) {
        const { mainPartnerId } = this.props.affiliates;
        const that = this;

        const data = {
            AffiliateId: row.id,
            Status: status
        };

        if (status === 2) {
            confirm({
                title: this.props.intl.messages.delete,
                content: <div className="ta--footer-delete-item ">
                    <p className='ta--pb-0'>{this.props.intl.messages.confirm_affiliate_delete}</p>
                </div>,
                okText: this.props.intl.messages.delete,
                onOk() {
                    that.props.dispatch(changeStatusAffiliate(data, that.props.intl)).then(() => {
                        that.props.dispatch(getAffiliates(mainPartnerId, that.state.pageNumber));
                    })
                },
                onCancel() {
                },
            });
        } else {
            that.props.dispatch(changeStatusAffiliate(data, that.props.intl)).then(() => {
                that.props.dispatch(getAffiliates(mainPartnerId, that.state.pageNumber));
            })
        }
    }

    liveChat = (affiliate) => {
        this.props.dispatch(getProjectId(affiliate.id)).then(res => {
            const chatURL = configs.BUILDER_URL + '/sso?token=' + encodeURI(Auth.token) + "&projectId=" + res.Data + "&page=settings";
            window.open(chatURL, '_blank');
        });

    }

    render() {
        const { allAffiliates } = this.props.affiliates;

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        const sorter = (a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        };

        const ellipsisMenu = (value, row) => {
            return (
                <Menu>
                    <Menu.Item key="0">
                        <Settings affiliateId={row.id} />
                    </Menu.Item>
                    <Menu.Item key="1">
                        <Permissions affId={row.id} />
                    </Menu.Item>
                    <Menu.Item key="2">
                        <Button className="clear_button_style"
                            onClick={(e) => this.handleChangeStatusAffiliate(e, row, 2)}
                            type="dashed">
                            {this.props.intl.messages.inactive}
                        </Button>
                    </Menu.Item>
                    <Menu.Item key="3">
                        {row.status === 1 ?
                            <Button className="clear_button_style"
                                onClick={(e) => this.handleChangeStatusAffiliate(e, row, 3)} type="dashed">
                                {this.props.intl.messages.block}
                            </Button> : row.status === 3 ?
                                <Button className="clear_button_style"
                                    onClick={(e) => this.handleChangeStatusAffiliate(e, row, 1)} type="dashed">
                                    {this.props.intl.messages.active}
                                </Button> : ""
                        }

                    </Menu.Item>
                    <Menu.Item key="4">
                        <AdvanceWithdraw affId={row.id} />
                    </Menu.Item>
                    <Menu.Item key="5">
                        <Button className="clear_button_style"
                                onClick={() => {this.liveChat(row)}}
                                type="dashed">
                            {this.props.intl.messages.live_chat}
                        </Button>
                    </Menu.Item>
                </Menu>
            )
        };

        const columns = [
            {
                title: this.props.intl.messages.id,
                dataIndex: 'id',
                key: 'id',
                filters: [],
                sorter: sorter,
                sortDirections: ['ascend' , 'descend'],
            },
            {
                title: this.props.intl.messages.email,
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: this.props.intl.messages.aff_name,
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: this.props.intl.messages.balance,
                dataIndex: 'balance',
                key: 'balance',
                render: value => Utils.numberWithCommas(value)
            },
            {
                title: this.props.intl.messages.status,
                dataIndex: 'status',
                key: 'status',
                render: (status, record) => (
                    record.status === 1 ?
                        <span className="ta--success ta--fw-b">{this.props.intl.messages.active}</span> :
                        record.status === 2 ?
                            <span className="ta--inactive ta--fw-b">{this.props.intl.messages.inactive}</span> :
                            record.status === 3 ?
                                <span className="ta--inactive ta--fw-b">{this.props.intl.messages.blocked}</span> : ""
                ),
            },
            {
                title: '',
                dataIndex: 'operation',
                key: 'operation',
                render: (value, row, index) => (
                    <Dropdown disabled={row.status === 2} overlay={ellipsisMenu(value, row, index)} trigger={['click']}>
                        <Icon className='ta--f-20' type={row.status !== 2 ? "ellipsis" : ""} />
                    </Dropdown>
                )
            },
        ];
        const data = allAffiliates ? Object.keys(allAffiliates.Affiliates).map(key => {
            return {
                key: allAffiliates.Affiliates[key].Id,
                id: allAffiliates.Affiliates[key].Id,
                email: allAffiliates.Affiliates[key].Email,
                name: allAffiliates.Affiliates[key].Name,
                balance: allAffiliates.Affiliates[key].Balance,
                status: allAffiliates.Affiliates[key].Status,
                active: allAffiliates.Affiliates[key].Status === 1 ? true : false,
            }
        }).sort(this.sorter) : [];

        return (
            <div>
                <div className="ta--flex ta--justify-between ta--align-center rtl--row-reverse">
                    <h2 className='ta--main-header'>{this.props.intl.messages.affiliates}</h2>
                    <AddAffiliate affiliatesData={this.state.pageNumber} />
                </div>
                <Spin indicatornpm={antIcon} spinning={this.props.affiliates.inProcess}>
                    <Table dataSource={data.sort(sorter)}
                        columns={columns} className="ta-aff-table ta--mt-8"
                        pagination={false}
                        footer={() => <div className='ta--flex ta--justify-between rtl--row-reverse'>
                            <div
                                className="ta--total-rows">{this.props.intl.messages.total_rows} : {allAffiliates && allAffiliates.RowCount}</div>
                            <div>{this.props.intl.messages.total} : <span
                                 className={allAffiliates && allAffiliates.TotalAmount > 0 ? "ta--green ta--fw-b" : "ta--red ta--fw-b"}>{allAffiliates && typeof allAffiliates.TotalAmount === 'number' && Utils.numberWithCommas(allAffiliates.TotalAmount)}</span>
                            </div>
                        </div>}>
                    </Table>
                    <Pagination defaultCurrent={1} pageSize={13} total={allAffiliates && allAffiliates.RowCount} onChange={this.onPageChange} />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Affiliates));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Affiliates/Affiliates.js